if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.alreadyInCart = false;
        this.paymentButtonObserver = null;

        this.checkIfInCart();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.alreadyInCart = true;
              this.updateCartCount();
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.querySelector('.loading__spinner').classList.add('hidden');

            if (this.alreadyInCart) {
              this.submitButtonText.textContent = 'Already in cart';
              this.submitButton.setAttribute('aria-disabled', 'true');
            } else if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            // Keep payment button enabled via observer
            this.watchPaymentButton();

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      updateCartCount() {
        fetch('/cart.js')
          .then((res) => res.json())
          .then((cart) => {
            const countText = document.getElementById('cart-count-text');
            const countBubble = document.getElementById('cart-count-bubble');
            const emptyIcon = document.getElementById('cart-icon-empty-svg');
            const fullIcon = document.getElementById('cart-icon-full-svg');

            if (countText) countText.textContent = cart.item_count;

            if (cart.item_count > 0) {
              if (countBubble) countBubble.style.display = '';
              if (emptyIcon) emptyIcon.style.display = 'none';
              if (fullIcon) fullIcon.style.display = '';
            } else {
              if (countBubble) countBubble.style.display = 'none';
              if (emptyIcon) emptyIcon.style.display = '';
              if (fullIcon) fullIcon.style.display = 'none';
            }
          })
          .catch((e) => console.error('Cart count update failed:', e));
      }

      checkIfInCart() {
        const variantId = this.variantIdInput.value;
        if (!variantId) return;

        fetch('/cart.js')
          .then((res) => res.json())
          .then((cart) => {
            const isInCart = cart.items.some(
              (item) => String(item.variant_id) === String(variantId)
            );
            if (isInCart) {
              this.alreadyInCart = true;
              this.submitButtonText.textContent = 'Already in cart';
              this.submitButton.setAttribute('aria-disabled', 'true');
              this.watchPaymentButton();
            }
          })
          .catch((e) => console.error('Cart check failed:', e));
      }

      watchPaymentButton() {
  if (this.paymentButtonObserver) {
    this.paymentButtonObserver.disconnect();
    this.paymentButtonObserver = null;
  }

  const enableBtn = () => {
    const wrapper = this.querySelector('shopify-buy-it-now-button');
    const innerBtn = this.querySelector('.shopify-payment-button__button');

    // Remove disabled from the wrapper element
    if (wrapper) {
      wrapper.removeAttribute('disabled');
    }

    // Also ensure inner button is enabled
    if (innerBtn) {
      innerBtn.removeAttribute('disabled');
      innerBtn.removeAttribute('aria-disabled');
      innerBtn.style.pointerEvents = 'auto';
      innerBtn.style.opacity = '1';
      innerBtn.style.cursor = 'pointer';
    }
  };

  const tryEnable = () => {
    const wrapper = this.querySelector('shopify-buy-it-now-button');
    if (wrapper) {
      enableBtn();

      // Watch the WRAPPER for disabled attribute changes
      this.paymentButtonObserver = new MutationObserver(() => {
        if (this.alreadyInCart) {
          enableBtn();
        }
      });

      this.paymentButtonObserver.observe(wrapper, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }
  };

  tryEnable();
  [100, 300, 600, 1000, 2000].forEach((delay) => {
    setTimeout(tryEnable, delay);
  });
}

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}